import { show, hide, trigger } from './utility';

/// show-depends-on-select-other is a special case for show-depends-on-select, this allow the
/// select value to end with Other instead of exact match. (e.g. 'h. Other').
///
/// <div data-gs-toggle="show-depends-on-select-other" data-gs-target="#target"></div>

function checkRowHasValue(elem: HTMLElement) {
    let textElems = elem.querySelectorAll("input");
    for (let i = 0; i < textElems.length; ++i) {
        let elemi = textElems[i];
        if (elemi.type == 'text' && elemi.value) {
            return true;
        }
        if (elemi.type == 'radio' && elemi.checked) {
            return true;
        }
    }
}

export default function (targetElem: HTMLElement) {
    let minStr = targetElem.dataset['gsMin'];
    if (!minStr) {
        throw new Error("please specify the minimal items to show");
    }
    let min = parseInt(minStr);
    if (isNaN(min) || min < 0) {
        throw new Error("please specify the minimal items to show");
    }
    let rows = targetElem.children;
    let firstNonEmpty = 0;
    let i = 0;
    for (i = rows.length - 1; i >= min; --i) {
        let rowi = <HTMLElement>rows[i];
        if (checkRowHasValue(rowi)) {
            break;
        }
        hide(rowi);
    }
    let firstHidden = i + 1;
    if (firstHidden < rows.length) {
        let btnElem = <HTMLButtonElement>document.createElement("BUTTON");
        btnElem.type = "button";
        btnElem.className = "btn btn-primary mt-2";
        btnElem.textContent = "Add More Rows";
        btnElem.addEventListener("click", (e) => {
            let firstHideElem = <HTMLElement>rows[firstHidden++]
            show(firstHideElem);
            if (firstHidden == rows.length - 1) {
                btnElem.remove();
            }
        });
        targetElem.appendChild(btnElem);
    }

}